// src/CartContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useGlobal } from './GlobalContext';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const { cart, refreshCart } = useGlobal();
  const [cartCount, setCartCount] = useState(0);

  // 🔹 CORREÇÃO: Sincronização com o cart
  useEffect(() => {
    if (cart && Array.isArray(cart.items)) {
      // 🔹 CALCULA CORRETAMENTE: Soma as quantidades de todos os itens
      const totalItems = cart.items.reduce((total, item) => {
        return total + (item.quantidade || 1);
      }, 0);

      setCartCount(totalItems);
    } else {
      setCartCount(0);
      // console.log('[CartContext] carrinho vazio ou inválido');
    }
  }, [cart]);

  // 🔹 Atualização inicial
  // useEffect(() => {
  //   console.log('[CartContext] Iniciando refreshCart...');
  //   if (typeof refreshCart === 'function') {
  //     refreshCart().catch((e) =>
  //       console.error('[CartContext] erro em refreshCart:', e),
  //     );
  //   }
  // }, [refreshCart]);

  const handleCartOperation = async (operation, items = []) => {
    try {
      const params = new URLSearchParams(window.location.search);
      const apartamento = params.get('x');
      const cliente_url = params.get('id_cliente');
      const session_control = params.get('session_control');
      const ip = localStorage.getItem('ip_address');
      const session = localStorage.getItem('session');
      const language = navigator.language || navigator.userLanguage || 'pt-BR';

      const payload = {
        cliente_id: cliente_url,
        ip_address: ip,
        session,
        language,
        operation,
        items,
      };

      const url = `${process.env.REACT_APP_URL_API}/apiv2/cart/update/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}&language=${language}`;

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();

      // 🔹 FORÇA atualização do carrinho
      if (typeof refreshCart === 'function') {
        await refreshCart();
      }

      return data;
    } catch (err) {
      console.error('[CartContext] Erro:', err);
      throw err;
    }
  };

  const addItemToCart = (itemId, quantity = 1, adicionais = []) =>
    handleCartOperation('add', [
      { id: itemId, quantity, additional_items: adicionais },
    ]);

  const removeItemFromCart = (itemId) =>
    handleCartOperation('remove', [{ id: itemId }]);

  const clearCart = () => handleCartOperation('clear');

  return (
    <CartContext.Provider
      value={{
        cartCount,
        addItemToCart,
        removeItemFromCart,
        clearCart,
        refreshCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
